import React, { useLayoutEffect } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';
import './index.css';

const PolicyPage = ({
    config,
    isFixed,
    userLocation,
    onLocationUpdate,
    userToken,
    userId,
    userPhone,
    onLogout,
    onShowAuthModal,
    nearestStore
}) => {
    const location = useLocation();
    const navigate = useNavigate();

    // Reset scroll to top immediately when policy changes
    useLayoutEffect(() => {
        window.scrollTo(0, 0);
        document.documentElement.scrollTo(0, 0);
        document.body.scrollTo(0, 0);
    }, [location.pathname]);

    // Get the current path (e.g., "/privacy-policy")
    const currentPath = location.pathname;

    // Find the policy from footer.policies array based on path
    const policy = config.footer.policies.find(p => p.path === currentPath);

    // Common Header props
    const headerProps = {
        isFixed: isFixed,
        logo: config.logo,
        navLinks: config.navLinks,
        restaurantName: config.name,
        basePath: config.basePath,
        userLocation: userLocation,
        onLocationUpdate: onLocationUpdate,
        userToken: userToken,
        userId: userId,
        userPhone: userPhone,
        onLogout: onLogout,
        onShowAuthModal: onShowAuthModal
    };

    // If policy doesn't exist in config, show 404
    if (!policy) {
        return (
            <div className="policy-page">
                <Header {...headerProps} />
                <main className="policy-main-content">
                    <div className="container">
                        <div className="policy-not-found">
                            <h1>404 - Policy Not Found</h1>
                            <button onClick={() => navigate(-1)} className="back-button">
                                <i className="fa fa-arrow-left"></i> Go Back
                            </button>
                        </div>
                    </div>
                </main>
                <Footer config={config} nearestStore={nearestStore} showNewsletter={false} />
            </div>
        );
    }

    // If htmlContent is empty or missing
    if (!policy.htmlContent || policy.htmlContent.trim().length === 0) {
        return (
            <div className="policy-page">
                <Header {...headerProps} />
                <main className="policy-main-content">
                    <div className="policy-header-section">
                        <div className="container">
                            <h1 className="policy-title">{policy.name}</h1>
                            <div className="policy-title-underline"></div>
                        </div>
                    </div>
                    <div className="policy-content">
                        <div className="container">
                            <div className="row">
                                <div className="col-12 col-lg-12 col-md-12 col-sm-12">
                                    <div className="policy-section">
                                        <p className="section-text" style={{ textAlign: 'center', color: '#d9534f' }}>
                                            Policy content is not available.
                                        </p>
                                        <p className="section-text" style={{ textAlign: 'center' }}>
                                            Please contact support for more information.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
                <Footer config={config} nearestStore={nearestStore} showNewsletter={false} />
            </div>
        );
    }

    return (
        <div className="policy-page">
            {/* Global Header */}
            <Header {...headerProps} />

            <main className="policy-main-content">
                {/* Policy Title Section */}
                <div className="policy-header-section">
                    <div className="container">
                        <div className="policy-header-inner">
                            <button onClick={() => navigate(-1)} className="back-button">
                                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M19 12H5M12 5l-7 7 7 7" />
                                </svg>
                                Back
                            </button>
                            <div className="policy-header-title-wrap">
                                <h1 className="policy-title">{policy.name}</h1>
                                <div className="policy-title-underline"></div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* HTML Content Section - Directly from config */}
                <div className="policy-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-lg-8 col-md-10 col-sm-12 col-lg-offset-2 col-md-offset-1">
                                <div className="policy-card">
                                    <div
                                        className="policy-html-content"
                                        dangerouslySetInnerHTML={{ __html: policy.htmlContent }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>


            {/* Global Footer */}
            <Footer config={config} nearestStore={nearestStore} showNewsletter={false} />
        </div>
    );
};

export default PolicyPage;